import React from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import Button from '../button/Button';
import RadioButtonList from '../radioButtonList/RadioButtonList';
import Select from 'react-select';
import { relationshipTypes } from '../../../utils/Constants';
import FormFaqAccordion from '../formFaqAccordion/formFaqAccordion';

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    boxShadow: state.isFocused ? '0px 0px 0px 1px #447b75' : `none`,
    padding: '0px 10px',
    border: '1px solid #333333',
    '&:hover': {
      boxShadow: state.isFocused ? '0px 0px 0px 1px #447b75' : `none`,
    },
    height: '48px',
  }),
  option: (provided, state) => ({
    padding: '10px 15px',
    background: state.isFocused
      ? 'rgba(138, 219, 209, 0.09)'
      : state.isSelected
      ? 'rgba(138, 219, 209, 0.09)'
      : `white`,
    color: `black`,
  }),
};

const Question3 = props => {
  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        <h3 className={`${styles.pageTitle}`}>Do you have an official role in the estate?</h3>
        <div className={`mb-5`}>
          <FormFaqAccordion
            title={`What are the “official roles in the estate”?`}
            icon={`Before_you_use_the_service.svg`}
            text={`<p>An “official role in the estate” means you have legal authority to act on behalf of the estate. There are different types of roles, including “Executor” (named in the Will) and “Administrator” (appointed to deal with the estate).</p>\r\n        </br><p>For more information about dealing with the will and estate of a person who has died, visit <a href=\"https://www.nsw.gov.au/life-events/what-to-do-when-someone-dies/after-a-death/dealing-will-and-estate\" target=\"_blank\">https://www.nsw.gov.au/life-events/what-to-do-when-someone-dies/after-a-death/dealing-will-and-estate</a></p>`}
          ></FormFaqAccordion>
        </div>
        <fieldset className={`nsw-form-fieldset ${styles.nswFormFieldset}`}>
          <RadioButtonList
            list={[
              {
                value: '2',
                label: 'Yes',
                checked:
                  props.hasOfficialRoleDetails && props.hasOfficialRoleDetails.value === '2'
                    ? true
                    : false,
              },
              {
                value: '1',
                label: 'No',
                checked:
                  props.hasOfficialRoleDetails && props.hasOfficialRoleDetails.value === '1'
                    ? true
                    : false,
              },
            ]}
            id={'hasOfficialRoleDetails'}
            name={'hasOfficialRoleDetails'}
            displayLayout={'horizontal'}
            className={`nsw-form-radio__input ${styles.nswFormRadio__input}`}
            handleChange={(item, name) => {
              if (item?.value === '1') {
                props.setContactOfficialRole(null);
              } else {
                props.setRelationshipType(null);
                props.setOfficialRoleFirstName(null);
                props.setOfficialRoleLastName(null);
                props.setOfficialRoleContactNumber(null);
                props.setOfficialRoleEmailAddress(null);
                props.setOfficialRoleType(null);
                props.setofficialPersonDetailsAvailable(null);
              }
              props.setHasOfficialRoleDetails(item);
            }}
          />
        </fieldset>
        {props.hasOfficialRoleDetails?.value === '1' ? (
          <div>
            <h4 className={`${styles.nswFormLabel} mt-5`}>
              What was your relationship with the person who has died?
            </h4>
            <Select
              id="relationship"
              onChange={obj => {
                props.setRelationshipType(obj);
              }}
              init
              className={`col-sm-7 col-lg-7 pl-0 mb-5 col-md-10`}
              classNamePrefix={'selectRelationship'}
              styles={customStyles}
              value={props.relationshipType}
              placeholder={'Please select'}
              options={relationshipTypes}
            />
          </div>
        ) : null}
        {props.hasOfficialRoleDetails?.value === '2' ? (
          <div>
            <h3 className={`${styles.pageTitle}`}>What is your role in the estate?</h3>
            <div className={`mb-5`}></div>
            <fieldset className={`nsw-form-fieldset ${styles.nswFormFieldset}`}>
              <RadioButtonList
                list={[
                  {
                    value: '2',
                    label: 'Executor',
                    checked:
                      props.contactOfficialRole && props.contactOfficialRole.value === '2'
                        ? true
                        : false,
                  },
                  {
                    value: '1',
                    label: 'Administrator',
                    checked:
                      props.contactOfficialRole && props.contactOfficialRole.value === '1'
                        ? true
                        : false,
                  },
                  {
                    value: '3',
                    label: 'Solicitor',
                    checked:
                      props.contactOfficialRole && props.contactOfficialRole.value === '3'
                        ? true
                        : false,
                  },
                ]}
                id={'contactOfficialRole'}
                name={'contactOfficialRole'}
                displayLayout={'horizontal'}
                className={`nsw-form-radio__input ${styles.nswFormRadio__input}`}
                handleChange={(item, name) => {
                  props.setContactOfficialRole(item);
                }}
              />
            </fieldset>
          </div>
        ) : null}
        <div className={styles.btnWrap}>
          <Button
            disabled={
              !props.hasOfficialRoleDetails ||
              (props.hasOfficialRoleDetails?.value === '1' && !props.relationshipType) ||
              (props.hasOfficialRoleDetails?.value === '2' && !props.contactOfficialRole)
            }
            onClick={() => {
              props.setCurrentQuestion(
                props.hasOfficialRoleDetails?.value === '1' ? 4 : props.saveContactDetails()
              );
            }}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Question3;
